import React from 'react';
import { Modal } from 'components/organisms/Modals/Modal';
import AccordionNotifications from '../NotificationAccordion';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { Notification } from 'types/notifications/notification.def';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { toast } from 'react-hot-toast';

interface INotificationsViewProps {
  readNotifications: Notification[];
  unReadNotifications: Notification[];
  unReadNotificationsCount: number;
  showReadNotifications: boolean;
  setShowReadNotifications: (value: boolean) => void;
}

const NotificationsView = ({
  readNotifications,
  unReadNotifications,
  unReadNotificationsCount,
  showReadNotifications,
  setShowReadNotifications
}: INotificationsViewProps) => {
  return (
    <Modal
      modalHead={'Centre de Notifications'}
      isShowingDefault={unReadNotificationsCount > 0}
      onCloseAction={() => setShowReadNotifications(false)}
      blockClose={unReadNotificationsCount > 0}
      onBlockCloseAction={() =>
        toast.error("Vous n'avez pas lu toutes les notifications 🤔")
      }
      width={'medium'}
      triggerButton={
        <IconButton
          icon={'Bell'}
          onClick={null}
          notificationsCount={unReadNotificationsCount}
        />
      }
    >
      <AccordionNotifications notifications={unReadNotifications} />
      {!showReadNotifications && (
        <ButtonWithText
          variant="text"
          content="Voir les notifications lues"
          onClick={() => setShowReadNotifications(true)}
        />
      )}
      {showReadNotifications && (
        <AccordionNotifications notifications={readNotifications} />
      )}
    </Modal>
  );
};
export default NotificationsView;
